import Icon from '@cobliteam/ui/icons';
import { getSingular } from '@cobliteam/utils/pluralize';
import type { GeofenceWithCategory } from '../../../types';

interface ItemContentProps {
  item: GeofenceWithCategory;
}

const GeofenceItem = ({ item }: ItemContentProps) => {
  if (!item) return null;
  return (
    <button type='button' tabIndex={0} className={'flex w-full items-center justify-between text-xs'}>
      <div className='flex items-center justify-center gap-2'>
        <Icon name={item.category.icon} className='text-accessory-sky-11' />
        <div className='flex flex-col text-left'>
          <span className='text-[10px] text-gray-10'>{getSingular(item.category.name)}</span>
          <span className='line-clamp-1'>{item.name}</span>
        </div>
      </div>
    </button>
  );
};

export default GeofenceItem;
